import type { IconSvgObject } from './types';

const Pulse01Icon: IconSvgObject = [
  ["path", { d: "M2 12H6L7.5 8L9.5 15L13 6L15.5 18L18 12H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Pulse01Icon;
